import * as React from 'react'

import Grid from '@material-ui/core/Grid'

import { User as TUser }                                from '../../api'
import { isStudent, isTeacher, seesAllPeopleInProcess } from '../../project-utils/permissions'
import { PermissionGuard }                              from '../atoms'
import loadable                                         from '../hocs/loadable'
import { User }                                         from '../organisms'

interface ProcessPeopleProps {
  student: TUser
  teacher: TUser
}

const AsTeacher = ({ student }) => (
  <Grid item xs={12}>
    <User user={student} />
  </Grid>
)

const AsStudent = ({ teacher }) => (
  <Grid item xs={12}>
    <User user={teacher} />
  </Grid>
)

const AsElse = ({ student, teacher }) => (
  <>
    <Grid item xs={12} md={6}>
      <User user={student} />
    </Grid>
    <Grid item xs={12} md={6}>
      <User user={teacher} />
    </Grid>
  </>
)

const ProcessPeople = ({
  teacher,
  student,
}: ProcessPeopleProps) => (
  <Grid container spacing={24} alignItems={'stretch'}>
    <PermissionGuard check={isStudent}>
      <AsStudent teacher={teacher} />
    </PermissionGuard>

    <PermissionGuard check={isTeacher}>
      <AsTeacher student={student} />
    </PermissionGuard>

    <PermissionGuard check={seesAllPeopleInProcess}>
      <AsElse student={student} teacher={teacher} />
    </PermissionGuard>
  </Grid>
)

export default loadable(ProcessPeople)



// WEBPACK FOOTER //
// ./src/components/molecules/ProcessPeople.tsx